import { PRIVATE_ADMIN_FORM_SCHEDULED_COMMAND, PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS } from "../Constants/PathsConstant";
import FormScheduledCommandView from "../Views/FormScheduledCommandView";
import TableScheduledCommandView from "../Views/TableScheduledCommandView";

export const ScheduledCommandRouter = [
  {
    path: PRIVATE_ADMIN_LIST_SCHEDULED_COMMANDS,
    element: <TableScheduledCommandView />,
    children: [
      
    ]
  },
  {
    path: PRIVATE_ADMIN_FORM_SCHEDULED_COMMAND + '/:id',
    element: <FormScheduledCommandView />,
    children: [
      
    ]
  }
];